module.exports = __webpack_public_path__ + "app/principal/modals/modal-confirm-portal-21W6iMdO.html";